<div class="field-dialog__content__scroll p-24" fxLayout="column" fusePerfectScrollbar>
  <div *ngIf="equipmentLogsMapped?.length">
    <ng-container *ngFor="let equipmentLog of equipmentLogsMapped; index as index">
      <div
        *ngIf="equipmentLogsMapped[index - 1]?.formattedCreatedAt !== equipmentLog?.formattedCreatedAt"
        class="log-date font-color-gray"
      >
        <p *ngIf="equipmentLog.formattedCreatedAt === todayDate">
          {{ 'EQUIPMENTS.DIALOG.HISTORIC.TODAY' | translate }}
        </p>
        <p *ngIf="equipmentLog.formattedCreatedAt === yesterdayDate">
          {{ 'EQUIPMENTS.DIALOG.HISTORIC.YESTERDAY' | translate }}
        </p>
        <p *ngIf="equipmentLog.formattedCreatedAt !== yesterdayDate && equipmentLog.formattedCreatedAt !== todayDate">
          {{ equipmentLog.formattedCreatedAt }}
        </p>
      </div>

      <div class="log">
        <div class="log-icon-wrapper">
          <div class="log-icon {{ equipmentLog.colorClass }}-bg">
            <img src="assets/images/icons/{{ equipmentLog.icon }}.svg" [alt]="equipmentLog.eventName" />
          </div>
          <span class="log-line"></span>
        </div>

        <div class="card mb-0">
          <div class="card__item mt-0">
            <div class="log-title">
              <div class="log-title__description">
                <span
                  class="log-event-type {{ equipmentLog.colorClass }}-text"
                  [innerHTML]="equipmentLog.eventName"
                ></span>
              </div>
              <div class="log-title__date font-color-gray">
                {{ equipmentLog.createdAt | date: 'dd/MM/yyyy HH:mm' }}
              </div>
            </div>
            <div *ngIf="equipmentLog.customAuthor" class="log-author-and-device font-color-gray">
              <mat-icon inline>{{ equipmentLog.customAuthorDevice }}</mat-icon>
              <span>{{ equipmentLog.customAuthor }}.</span>
            </div>

            <div class="log-content font-color-gray">
              <p
                *ngIf="equipmentLog.eventDescription"
                [innerHTML]="equipmentLog.eventDescription"
                class="log-description"
              ></p>

              <ng-container class="approvals" *ngIf="equipmentLog.approval && equipmentLog.showDiffApproval">
                <p
                  *ngIf="equipmentLog.approval.nameDescription"
                  [innerHTML]="equipmentLog.approval.nameDescription"
                  class="approvals__item"
                ></p>

                <p
                  *ngIf="equipmentLog.approval.numberDescription"
                  [innerHTML]="equipmentLog.approval.numberDescription"
                  class="approvals__item"
                ></p>

                <p
                  *ngIf="equipmentLog.approval.locationDescription"
                  [innerHTML]="equipmentLog.approval.locationDescription"
                  class="approvals__item"
                ></p>

                <p
                  *ngIf="equipmentLog.approval.typeDescription"
                  [innerHTML]="equipmentLog.approval.typeDescription"
                  class="approvals__item"
                ></p>

                <div *ngIf="equipmentLog.approval.notesDescription">
                  <p class="approvals__notes-title" [innerHTML]="equipmentLog.approval.notesDescription.title"></p>
                  <p class="approvals__notes-description">{{ equipmentLog.approval.notesDescription.notes }}</p>
                </div>
              </ng-container>

              <ng-container *ngIf="equipmentLog.customFields">
                <div class="custom-fields" *ngIf="equipmentLog.customFields.added.items.length">
                  <p class="custom-fields__title" [innerHTML]="equipmentLog.customFields.added.title"></p>
                  <div *ngFor="let item of equipmentLog.customFields.added.items">
                    <p class="custom-fields__name" [innerHTML]="item.name"></p>
                    <p class="custom-fields__value">{{ item.value }}</p>
                  </div>
                </div>

                <div class="custom-fields" *ngIf="equipmentLog.customFields.updated.items.length">
                  <p class="custom-fields__title" [innerHTML]="equipmentLog.customFields.updated.title"></p>
                  <div *ngFor="let item of equipmentLog.customFields.updated.items">
                    <p class="custom-fields__name" [innerHTML]="item.name"></p>
                    <p *ngIf="item.value" class="custom-fields__value">{{ item.value }}</p>
                    <p *ngIf="!item.value" class="without-answer">
                      {{ 'EQUIPMENTS.DIALOG.HISTORIC.EVENTS.CUSTOM_FIELDS.WITHOUT_ANSWER' | translate }}
                    </p>
                  </div>
                </div>

                <div class="custom-fields" *ngIf="equipmentLog.customFields.removed.items.length">
                  <p class="custom-fields__title" [innerHTML]="equipmentLog.customFields.removed.title"></p>
                  <div *ngFor="let item of equipmentLog.customFields.removed.items">
                    <p class="custom-fields__name" [innerHTML]="item.name"></p>
                    <p class="custom-fields__value">{{ item.value }}</p>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="equipmentLog.attachments">
                <div
                  class="attachments"
                  *ngIf="equipmentLog.attachments.added && equipmentLog.attachments.added.items.length"
                >
                  <p
                    class="attachments__title"
                    *ngIf="equipmentLog.attachments.added.title"
                    [innerHTML]="equipmentLog.attachments.added.title"
                  ></p>
                  <div fxLayout="row" *ngFor="let item of equipmentLog.attachments.added.items">
                    <div class="attachments__image" [style.backgroundImage]="'url(' + item.path + ')'"></div>
                  </div>
                </div>

                <div
                  class="attachments"
                  *ngIf="equipmentLog.attachments.removed && equipmentLog.attachments.removed.items.length"
                >
                  <p
                    class="attachments__title"
                    *ngIf="equipmentLog.attachments.removed.title"
                    [innerHTML]="equipmentLog.attachments.removed.title"
                  ></p>
                  <div fxLayout="row" *ngFor="let item of equipmentLog.attachments.removed.items">
                    <div class="attachments__image" [style.backgroundImage]="'url(' + item.path + ')'"></div>
                  </div>
                </div>
              </ng-container>

              <button
                *ngIf="equipmentLog.approval"
                class="view-approval-button"
                mat-button
                (click)="openDialog(equipmentLog.approval)"
              >
                {{ 'EQUIPMENTS.DIALOG.HISTORIC.EVENTS.APPROVALS.VIEW_APPROVAL' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div *ngIf="!equipmentLogsMapped?.length" fxLayout="column" fxLayoutAlign="center center" class="p-24">
    <p fxFlex="100" fxLayout="row" fxLayoutAlign="center center">
      <mat-icon class="font-size-32">history</mat-icon>
    </p>
    <span class="h3">
      {{ 'EQUIPMENTS.DIALOG.HISTORIC.NO_HISTORIC' | translate }}
    </span>
  </div>
</div>
